import React from 'react';
import { programsData } from '../../data/programsData';
import RightArrow from '../../assets/rightArrow.png';
import './programs.css';
const programs = () => {
    return (
        <div className="programs" id="programs">

            {/* header */}
            <div className="programs-header">
                <span className='stroke-text'>Explore our</span>
                <span>Programs</span>
                <span className='stroke-text'>to Shape you</span>
            </div>

            <div className="programs-catagories">
                {programsData.map((program) => (
                    <div className="catagory">
                        {program.image}
                        <span>{program.heading}</span>
                        <span>{program.details}</span>
                        <div className="join-now">
                            <span>Join Now</span>
                            <img src={RightArrow} alt="" />
                        </div>
                    </div>
                )
                )}
            </div>
        </div>
    )
}

export default programs;